// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/auth/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/auth/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/auth/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注册接口 */
export async function register(body: API.RegisterParams, options?: { [key: string]: any }) {
  return request<API.RegisterResult>('/api/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data:{
      method: 'update',
      ...(options || {}),
    }
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data:{
      method: 'post',
      ...(options || {}),
    }
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data:{
      method: 'delete',
      ...(options || {}),
    }
  });
}

/** 获取项目列表 GET /api/project */
export async function getProjects(
  params: {
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
    /** 项目名称 */
    name?: string;
    /** 项目状态 */
    status?: API.ProjectStatus;
    /** 项目优先级 */
    priority?: API.ProjectPriority;
  },
  options?: { [key: string]: any },
) {
  return request<API.ProjectList>('/api/project', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建项目 POST /api/project */
export async function addProject(body: Partial<API.ProjectListItem>, options?: { [key: string]: any }) {
  return request<API.ProjectListItem>('/api/project', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新项目 PUT /api/project/:id */
export async function updateProject(
  id: string,
  body: Partial<API.ProjectListItem>,
  options?: { [key: string]: any },
) {
  return request<API.ProjectListItem>(`/api/project/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除项目 DELETE /api/project/:id */
export async function removeProject(id: string, options?: { [key: string]: any }) {
  return request<Record<string, any>>(`/api/project/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取项目详情 GET /api/project/:id */
export async function getProjectDetail(id: string, options?: { [key: string]: any }) {
  return request<{
    data: API.ProjectListItem;
  }>(`/api/project/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取项目甘特图数据 GET /api/project/gantt */
export async function getProjectGantt(
  params?: {
    projectId?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ProjectGanttData>('/api/project/gantt', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 更新任务 PUT /api/project/gantt/task/:id */
export async function updateTask(
  id: string | number,
  body: API.GanttTask,
  options?: { [key: string]: any },
) {
  return request<API.GanttTask>(`/api/project/gantt/task/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 新建任务 POST /api/project/gantt/task */
export async function addTask(
  body: API.GanttTask,
  options?: { [key: string]: any },
) {
  return request<API.GanttTask>('/api/project/gantt/task', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除任务 DELETE /api/project/gantt/task/:id */
export async function removeTask(
  id: string | number,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/project/gantt/task/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 更新任务链接 PUT /api/project/gantt/link/:id */
export async function updateLink(
  id: string | number,
  body: API.GanttLink,
  options?: { [key: string]: any },
) {
  return request<API.GanttLink>(`/api/project/gantt/link/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 新建任务链接 POST /api/project/gantt/link */
export async function addLink(
  body: API.GanttLink,
  options?: { [key: string]: any },
) {
  return request<API.GanttLink>('/api/project/gantt/link', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 删除任务链接 DELETE /api/project/gantt/link/:id */
export async function removeLink(
  id: string | number,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/project/gantt/link/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
